// import agentList from './agentList'

export default {
  // 一级菜单
  firstMenuList: [
    {
      icon: 'ios-paper',
      name: '应用管理',
      oldKey: 'ApplicationManagement',
    },
  ],
  // 二级菜单
  secondMenuList: [
    {
      icon: 'ios-list-outline',
      name: '服务管理',
      oldKey: 'ApplicationManagementList',
    },
    {
      icon: 'ios-list-outline',
      name: '美团设置',
      oldKey: 'MeiTuanSetting',
    },
    {
      icon: 'ios-list-outline',
      name: '抖音设置',
      oldKey: 'DouYinSetting',
    },
  ],
  // 三级菜单
  thirdMenuList: [
    {
      icon: 'ios-list-outline',
      name: '库存配置',
      routerName: 'ApplicationManagementList',
      oldKey: 'ApplicationManagementList1',
    },
    {
      icon: 'ios-list-outline',
      name: '时间段设置',
      routerName: 'Trigger',
      oldKey: 'trigger',
    },
    {
      icon: 'ios-list-outline',
      name: '自动接单配置 ',
      routerName: 'GlobalVariable',
      oldKey: 'globalVariable',
    },
    {
      icon: 'ios-list-outline',
      name: '预约单',
      routerName: 'Appointment',
      oldKey: 'Appointment',
    },
    {
      icon: 'ios-list-outline',
      name: 'SKU管理',
      routerName: 'SingleSet',
      oldKey: 'MeiTuanSingleSet',
    },
    {
      icon: 'ios-list-outline',
      name: '系统设置',
      routerName: 'MeiTuanSystemSetting',
      oldKey: 'MeiTuanSystemSetting',
    },
    {
      icon: 'ios-list-outline',
      name: '系统设置',
      routerName: 'DouYinSystemSetting',
      oldKey: 'DouYinSystemSetting',
    },
    {
      icon: 'ios-list-outline',
      name: 'SKU管理',
      routerName: 'DouYinSKU',
      oldKey: 'DouYinSKU',
    },
    {
      icon: 'ios-list-outline',
      name: '商品管理',
      routerName: 'DouYinProduct',
      oldKey: 'DouYinProduct',
    },
    {
      icon: 'ios-list-outline',
      name: '订单列表',
      routerName: 'DouYinOrderList',
      oldKey: 'DouYinOrderList',
    },
    {
      icon: 'ios-list-outline',
      name: '抖音门店列表',
      routerName: 'DouYinStore',
      oldKey: 'DouYinStore',
    },
    {
      icon: 'ios-list-outline',
      name: '美团门店列表',
      routerName: 'MeituanStore',
      oldKey: 'MeituanStore',
    },
    {
      icon: 'ios-list-outline',
      name: '抖音账号授权',
      routerName: 'DouYinAuth',
      oldKey: 'DouYinAuth',
    },
    {
      icon: 'ios-list-outline',
      name: '美团账号授权',
      routerName: 'MeituanAuth',
      oldKey: 'MeituanAuth',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/list.js